import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const CancellationPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#FAF8F5] to-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <Button
          onClick={() => navigate(-1)}
          variant="outline"
          className="mb-6 border-[#6B0B0B] text-[#6B0B0B] hover:bg-[#6B0B0B] hover:text-white"
        >
          <ArrowLeft className="mr-2" size={18} />
          Back
        </Button>

        <div className="bg-white rounded-2xl shadow-lg border border-[#D4AF37]/20 p-8 md:p-12">
          <h1 className="text-4xl font-bold text-[#6B0B0B] mb-2">Cancellation & Refund Policy</h1>
          <p className="text-sm text-gray-500 mb-8">Last updated: 23 October 2026</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <div className="bg-[#FFF9F0] border-l-4 border-[#D4AF37] p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                This Cancellation and Refund Policy forms part of our Terms of Service. Your rights under the Consumer Protection Act 68 of 2008 are not limited by this policy.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold text-[#0B090A] mb-4 border-b-2 border-[#6B0B0B] pb-2">Cancellation by You</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You may cancel your booking at any time by emailing info@capeatiantictours.co.za with your booking reference. The following cancellation fees apply:
              </p>
              <ul className="text-gray-700 space-y-2">
                <li><strong>More than 7 days before tour:</strong> Full refund</li>
                <li><strong>4-7 days before tour:</strong> 50% refund</li>
                <li><strong>Less than 4 days before tour:</strong> No refund</li>
                <li><strong>No-show:</strong> No refund</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                <strong>Exception:</strong> No cancellation fee applies if you cannot honour the booking due to death or hospitalisation (proof required).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B090A] mb-4 border-b-2 border-[#6B0B0B] pb-2">Contact for Cancellations</h2>
              <div className="bg-[#FFF9F0] p-6 rounded-lg">
                <p className="text-gray-700">Email: info@capeatiantictours.co.za</p>
                <p className="text-gray-700">Telephone: 073 654 0090</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
